// Chip "Nivel Oro/Plata/Bronce" (mock: esquina superior derecha de los pasos 06-09 y marquesina de
// promos). Fuente: `session.loan.level`; el color sale de la píldora compartida, no de una paleta local.
import { TierPill } from '@/shared/patterns/Pills';
import { toTierValue } from '../clientLevel';
import type { ClientLevel } from '../types';

/** Las dos densidades del wizard, traducidas a la escala de la píldora compartida. */
const PILL_BY_SIZE = {
    md: { size: 'sm', label: 'full' },
    sm: { size: 'xs', label: 'short' },
} as const;

export function LevelChip({
    level,
    size = 'md',
}: {
    level?: ClientLevel;
    /** `sm` recorta el «Nivel» — en la marquesina de promos el chip es una marca, no un rótulo. */
    size?: keyof typeof PILL_BY_SIZE;
}) {
    const pill = PILL_BY_SIZE[size];
    return <TierPill level={toTierValue(level)} label={pill.label} size={pill.size} />;
}
